<template>
  <div class="contacts section__container">
    <hr class="contacts__line">
    <Breadcrumbs/>
    <div class="contacts__block">
      <Contact class="contacts__block--text" />
      <FormContact class="contacts__block--form" />
    </div>
  </div>
</template>

<script>
import Breadcrumbs from './_breadcrumbs/component.vue';
import Contact from './_contact/component.vue';
import FormContact from './_form/component';

export default {
  name: "ContactsPage",
  components: { FormContact, Contact, Breadcrumbs }
}

</script>

<style src="./component.scss" scoped lang="scss"/>
